export const types = {
  PUSH_SHORTCUT_GROUP: 'PUSH_SHORTCUT_GROUP',
  POP_SHORTCUT_GROUP: 'POP_SHORTCUT_GROUP',
  CLEAR_SHORTCUT_GROUPS: 'CLEAR_SHORTCUT_GROUPS',
}
